import { Facade } from "@/modules/budget/monitoring/input-forms/types/roots/Facade";
import { FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/types/roots/FilterSettingsForm";
import { App41FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/components/application41/app41InputForm";

export class App41InputFormFacade implements Facade {
    getFilterSettings(): FilterSettingsForm {
        const form: App41FilterSettingsForm = {
            user_id: "",
            edit_access: false,
            delete_access: false,
            convert: 1000,
            application: null,
            child_status: null
        }
        return form
    }

}
`
[genView.vue]
[FormData.vue]
[application_41.vue]
[targetIndicators.vue]
[input_form_41.py]
`